<template>
	<div class="container2">
		<div class="main-img">
			<el-carousel :interval="5000" arrow="always" class="main-img-all">
				<el-carousel-item v-for="(item,index) in imgList" :key="index" class="main-img-lb">
					<el-image class="main-img1"
						:src="item.img"></el-image>
				</el-carousel-item>
			</el-carousel>
		</div>
		<div class="menu">
			<div class="menu-left">
				<div class="menu-left1">叠加式共享充电宝租赁机</div>
				<div class="menu-left2">叠加式、可拆分共享充电宝机柜</div>
				<div class="menu-left2">电源输入：AC100-240V-0.4A50/60HZ</div>
				<div class="menu-left2">型号：BD-GX-V-1</div>
				<div class="menu-left2">电源输出：DC5V6A（CCC认证电源）</div>
				<div class="menu-left2">产品尺寸：长23cm，宽19cm，高27.4cm</div>
				<div class="menu-left2">单口输出：DC5V-2A</div>
				<div class="menu-left2">产品槽位：8个充电宝槽位</div>
				<div class="menu-left2">单台重量：5KG</div>
				<div class="menu-left2">网络：4G增强式物联网卡</div>
			</div>
			<div class="menu-right">
				<el-image class="menu-right-img"
					:src="require('../../assets/img/powerbank/1.jpeg')"></el-image>
			</div>
		</div>
		<div class="advantage1">
			<div class="advantage1-all">
				<div class="advantage1-all-img">
					<img src="//19164467.s61i.faiusr.com/4/AD0Is9qRCRAEGAAg1Yzm9wUovOHh8gcwsAk4sAk!100x100.png.webp" />
				</div>
				<div class="advantage1-all-text">
					<div class="advantage1-all-text1">叠加式</div>
					<div class="advantage1-all-text2">
						能量工厂叠加式共享充电宝组合机柜，市场前景开阔
					</div>
				</div>
			</div>
			<div class="advantage1-all">
				<div class="advantage1-all-img">
					<img src="//19164467.s61i.faiusr.com/4/AD0Is9qRCRAEGAAg7Izm9wUopLPZ2gMwsAk4sAk!100x100.png.webp" />
				</div>
				<div class="advantage1-all-text">
					<div class="advantage1-all-text1">专利设计</div>
					<div class="advantage1-all-text2">
						乐园互联网申请专利，可支持共享充电宝订制和代理加盟能量工厂
					</div>
				</div>
			</div>
			<div class="advantage1-all">
				<div class="advantage1-all-img">
					<img src="//19164467.s61i.faiusr.com/4/AD0Is9qRCRAEGAAgo43m9wUozNrN4wEwsAk4sAk!100x100.png.webp" />
				</div>
				<div class="advantage1-all-text">
					<div class="advantage1-all-text1">彩宝设计</div>
					<div class="advantage1-all-text2">
						充电宝为动力电池电芯，彩宝设计，带呼吸灯
					</div>
				</div>
			</div>
			<div class="advantage1-all">
				<div class="advantage1-all-img">
					<img src="//19164467.s61i.faiusr.com/4/AD0Is9qRCRAEGAAguo3m9wUo4JqjlAUwsAk4sAk!100x100.png.webp" />
				</div>
				<div class="advantage1-all-text">
					<div class="advantage1-all-text1">代理门槛低</div>
					<div class="advantage1-all-text2">
						能量工厂共享充电宝加盟门槛低，10台起即可加盟
					</div>
				</div>
			</div>
		</div>
		<div class="menu3">
			<div class="menu3-top">
				<div class="menu3-top1">能量工厂充电宝-共享充电宝知名品牌</div>
				<div class="menu3-top3">THE MAIN TITLE</div>
				<div class="menu3-top2">能量工厂充电线是深圳市乐园互联网科技旗下的共享充电线知名品牌，能量工厂充电线可通过支付宝免押金租借
					，微信扫码借还方便，还可以为能量工厂商家进行优惠活动推送，提供引流客源服务，能量工厂代理加盟商分润秒结算。总部厂家直销全国招募合伙人。</div>
				<div class="menu3-top4">能量工厂充电线-能量工厂共享充电线产品优势介绍</div>
				<div class="menu3-main">
					<div class="menu3-main1" v-for="(item,index) in youshilist" :key="index">
						<div class="menu3-main1-img">
							<el-image class="menu3-main1-img1"
								:src="item.img"></el-image>
						</div>
						<div class="menu3-main1-text">
							<div class="menu3-main1-text1">{{item.text}}</div>
							<div class="menu3-main1-text2">{{item.text2}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="product">
			<div class="product1">能量工厂共享充电线</div>
			<div class="product2">能量工厂共享充电线是乐园互联网科技的主打产品，3U口输出支持TYPE-C、安卓、苹果三个接口，满足各类智能手机用需求。适用通用场景。</div>
			<div class="product3">
				<div class="product3-img">
					<el-image class="product3-img1"
						:src="require('../../assets/img/cable/nlgc1.png')"></el-image>
				</div>
				<div class="product4">
					<div class="product4-text1">共享充电线</div>
					<div class="product4-text2">1、一线三充</div>
					<div class="product4-text2">2、收益秒到</div>
					<div class="product4-text2">3、大品牌行业TOP3</div>
					<div class="product4-text2">4、7*24小时在线客服</div>
					<div class="product4-text2">5、阻燃材料，保证安全</div>
					<div class="product4-text2">6、千万保险，助力护航</div>
					<div class="product4-text2">7、线充免费发、退、换、补</div>
					<div class="product4-text2">8、额外非房收入</div>
					<div class="product4-text2">9、80%真实分成</div>
					<div class="product4-text2">10、3C安全认证</div>
					<div class="product4-text2">11、设备美观、清晰好用</div>
				</div>
			</div>
		</div>
		<div class="product">
			<div class="product1">能量工厂充电线资质展示</div>
			<div class="product2">能量工厂拥有多项软硬件专利，符合国家3C配件批量生产标准，产品从设计到软件均是乐园互联网科技半年多的成果。
				在共享充电线、共享充电宝被大家认可的今天，乐园互联网作为后起之秀，必然是用实力说话的好品牌。</div>
			<div class="product5">
				<div class="product5-all">
					<div class="product5-img">
						<el-image class="product5-img1"
							src="//16856361.s21i.faiusr.com/2/ABUIABACGAAgu9SH5gUosJ7omAEw7QM4wAM.jpg.webp"></el-image>
					</div>
					<div class="product5-text">
						<div class="product5-text1">
							能量工厂充电线产品测试证书
						</div>
					</div>
				</div>
				<div class="product5-all">
					<div class="product5-img">
						<el-image class="product5-img1"
							src="//16856361.s21i.faiusr.com/2/ABUIABACGAAg-pnA_AUomKH80gIwvwc49gU!600x600.jpg.webp"></el-image>
					</div>
					<div class="product5-text">
						<div class="product5-text1">
							能量工厂充电线外观专利证书
						</div>
					</div>
				</div>
				<div class="product5-all">
					<div class="product5-img">
						<el-image class="product5-img1"
							src="//16856361.s21i.faiusr.com/2/ABUIABACGAAg2NSH5gUo6IKJkAUw7QM4wAM.jpg.webp"></el-image>
					</div>
					<div class="product5-text">
						<div class="product5-text1">
							能量工厂充电线航空运输鉴别报告书
						</div>
					</div>
				</div>
				<div class="product5-all">
					<div class="product5-img">
						<el-image class="product5-img1"
							src="//16856361.s21i.faiusr.com/2/ABUIABACGAAgg9aH5gUo7JnU8AEw7QM4wAM.jpg.webp"></el-image>
					</div>
					<div class="product5-text">
						<div class="product5-text1">
							能量工厂充电线欧盟进出口许可证书
						</div>
					</div>
				</div>
				
			</div>
		</div>
		<div class="product">
			<div class="product3">
				<div class="product3-img">
					<el-image class="product3-img1"
						:src="require('../../assets/img/cable/nlgc2.jpg')"></el-image>
				</div>
				<div class="product6">
					<div class="product6-top">
						<div class="product6-top1">
							<div class="product6-top1-text1">01</div>
							<div class="product6-top1-text2">撞色设计</div>
							<div class="product6-top1-text3">用户能一眼清晰辨认使用方法及售后电话使用起来非常方便快捷。</div>
						</div>
						<div class="product6-top2">
							<div class="product6-top1-text1">02</div>
							<div class="product6-top1-text2">二维码支付</div>
							<div class="product6-top1-text3 color-text">搭载基于A-GPS的精准导航空位，可实现在任何城市中提供小于30M的精准定位。打开小程序可以看到商家店铺充电宝定位情况。</div>
						</div>
					</div>
					<div class="product6-fot">
						<div class="product6-top1">
							<div class="product6-top1-text1">03</div>
							<div class="product6-top1-text2">3U口输出</div>
							<div class="product6-top1-text3 color-text">能量工厂充电宝自带TYPE-C、苹果Lightning、安卓Micro-usb三种充电头，经过测试能够满足99%的智能手机。独立三线设计。</div>
						</div>
						<div class="product6-top2">
							<div class="product6-top1-text1">04</div>
							<div class="product6-top1-text2">人性化设计</div>
							<div class="product6-top1-text3">对于急需没电急需充电的用户输入6个2可以免费充电五分钟。</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="fotter">
			<div class="fotter1">
				<div class="fotter1-text">
					<span class="color-text3">能量工厂</span>
					<span>官网-深圳市乐园互联网科技有限公司</span>
				</div>
				<div class="fotter1-text2">
					<div class="fotter1-text2-1">
						<span>能量工厂-全球十大</span>
						<span class="color-text">共享充电线</span>
						<span>品牌之一，</span>
						<span class="color-text2">能量工厂3c认证</span>
					</div>
					<div class="fotter1-text2-2">
						<span class="fotter1-text2-2-left color-text3">共享充电线</span>
						<span>，共享充电宝加盟代理，</span>
						<span class="fotter1-text2-2-left color-text3">共享WiFi贴</span>
						<span>，酒店售货机厂家招商加盟</span>
					</div>
					<div class="fotter1-text2-3">
						<span>代理加盟咨询招商总监：王总 </span>
						<span class="color-text3">18664573264</span>
						<span> 微信同号</span>
					</div>
					<div class="fotter1-text2-4">
						<span>公司总部：广东省深圳市宝安区新桥街道上星社区上星路万科星城星宸大厦第3栋6楼整层</span>
					</div>
				</div>
			</div>
			<div class="fotter2">
				<el-image src="../../assets/img/erweim1.png"></el-image>
			</div>
		</div>
		
	</div>
</template>

<script>
	export default {
		data() {
			return {
				imgList:[
					{
						id:1,
						img:require('../../assets/img/main/7.jpeg')
					},
					{
						id:2,
						img:require('../../assets/img/main/8.jpeg')
					},
					{
						id:3,
						img:require('../../assets/img/main/9.jpeg')
					},
				],
				youshilist:[
					{
						id:1,
						img:'//19164467.s61i.faiusr.com/4/AD0Is9qRCRAEGAAggvSnkwYorKvksgMwsAk4sAk.png',
						text:'OTA代运营',
						text2:'一家好的代运营公司可以帮助酒店快速提升收入增长，我司提供免费的OTA代运营，佣金为市场最低，只为了酒店收入增长的保驾护航'
					},
					{
						id:2,
						img:'//19164467.s61i.faiusr.com/4/AD0Is9qRCRAEGAAgpvWnkwYoqoXa0AMwsAk4sAk.png',
						text:'投放补贴',
						text2:'成功合作以后，我司将补贴一定金额的红包给到客房阿姨，减轻酒店需要安排人员投放的成本。'
					},
					{
						id:3,
						img:'//19164467.s61i.faiusr.com/4/AD0Is9qRCRAEGAAgkP2nkwYooMaNmgUwsAk4sAk.png',
						text:'独立后台',
						text2:'合作商户拥有完全独立后台，收益秒到账，提现秒到，单笔提现仅收取5元/笔通道费用。'
					},
					{
						id:4,
						img:'//19164467.s61i.faiusr.com/4/AD0Is9qRCRAEGAAg1-SnkwYoncbEPzCwCTiwCQ.png',
						text:'0成本高回报',
						text2:'设备完全免费寄、换、退、补，全程设备成本、运费均由我司承担，同时给酒店80%真实分成，百分百可靠。'
					},
				]
			}
		},
		methods: {

		}
	}
</script>

<style scoped>
	.container2 {
		background: #ffffff;
		padding-bottom: 20px;
	}

	.main-img-all {
		width: 100%;
	}

	.main-img-lb {
		/* height: 420px; */
	}

	.main-img1 {
		width: 100%;
		height: 440px;
	}

	::v-deep .el-carousel__container {
		/* height: 450px; */
		min-height: 440px;
	}

	.menu {
		display: flex;
		padding: 50px 50px;
		padding-left: 12%;
		padding-right: 12%;
	}

	.menu-left {
		width: 50%;
		text-align: left;
	}

	.menu-right {
		width: 50%;
	}

	.menu-left1 {
		color: rgb(30, 80, 174);
		font-size: 30px;
		margin-bottom: 20px;
	}

	.menu-left2 {
		color: rgb(153, 153, 153);
		font-size: 14px;
		line-height: 30px;
	}

	.menu-right-img {
		width: 70%;
	}

	.advantage1 {
		display: flex;
		position: relative;
		margin-top: 20px;
		margin-left: 10%;
		margin-right: 10%;
		padding-top: 20px;
		flex-wrap: wrap;
	}

	.advantage1-all {
		width: 25%;
		/* flex: 1; */
		max-width: 100%;
	}

	.advantage1-all-img img {
		width: 36px;
		height: 36px;
	}

	.advantage1-all-text1 {
		font-size: 20px;
		text-align: center;
	}

	.advantage1-all-text {
		width: 61%;
		line-height: 30px;
		margin: 15px auto;
	}

	.advantage1-all-text2 {
		font-size: 14px;
		color: rgb(153, 153, 153);
	}

	.menu3 {
		padding-left: 13%;
		padding-right: 13%;
	}

	.menu3-top1 {
		font-size: 24px;
		color: rgb(30, 80, 174);
		text-align: center;
		line-height: 46px;
	}

	.menu3-top2 {
		color: rgb(51, 51, 51);
		text-align: center;
		font-size: 16px;
		width: 71%;
		margin: 10px auto;
	}

	.menu3-top3 {
		color: rgb(153, 153, 153);
		font-size: 14px;
	}

	.menu3-top4 {
		font-size: 28px;
		line-height: 30px;
		margin-top: 20px;
	}

	.menu3-main {
		margin-top: 10px;
		display: flex;
		align-items: center;
		/* flex-wrap: wrap; */
	}

	.menu3-main1 {
		background-color: rgba(245, 245, 245, 1);
		background-size: auto;
		background-repeat: repeat;
		background-position: center center;
		padding: 5% 2%;
		width: 23.5%;
		border-radius: 2px;
		box-sizing: border-box;
		display: flex;
		/* align-items: center; */
		text-align: left;
		margin-left: 2%;
		height: 275px;
	}

	.menu3-main1-img1 {
		width: 60px;
		height: 60px;
	}

	.menu3-main1-text {
		margin-left: 15px;
	}

	.menu3-main1-text1 {
		font-size: 20px;
		font-weight: initial;
		font-style: initial;
		font-family: 微软雅黑;
		text-decoration: initial;
		color: #212121;
	}

	.menu3-main1-text2 {
		-webkit-background-clip: text;
		color: #999;
		font-size: 14px;
		line-height: 22px;
		margin-top: 12px;
		word-break: break-word;
	}

	.product {
		margin-top: 30px;
		padding-left: 12%;
		padding-right: 12%;
	}

	.product1 {
		text-align: center;
		font-size: 24px;
	}

	.product2 {
		margin-top: 10px;
		text-align: center;
		font-size: 16px;
		white-space: normal;
	}

	.product3 {
		display: flex;
		margin-top: 3%;
	}

	.product3-img {
		width: 50%;
	}

	.product4 {
		width: 50%;
		text-align: left;
	}

	.product3-img1 {
		width: 40%;
	}

	.product4-text1 {
		font-size: 20px;
		margin-bottom: 20px;
		font-weight: bold;
	}

	.product4-text2 {
		font-size: 16px;
		line-height: 30px;
		font-weight: bold;
	}

	.product5 {
		margin: 5% auto;
		display: flex;
		/* align-items: center; */
		/* flex-wrap: wrap; */
	}

	.product5-all {
		width: 23.5%;
		margin-left: 3%;
		position: relative;
	}

	.product5-img1 {
		width: 100%;
	}

	.product5-text {
		background: rgba(0, 0, 0, .7);
		bottom: 0;
		color: #fff;
		font-size: 15px;
		height: 44px;
		line-height: 44px;
		position: absolute;
		text-align: center;
		transform: translateZ(0);
		transition: all .3s;
		width: 100%;
	}

	.product5-text1 {
		display: inline-block;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		width: 94%;
	}
	.product6{
		width: 50%;
		text-align: left;
		
	}
	.product6-top{
		display: flex;
		align-items: center;
	}
	.product6-top1{
		width: 42%;
	}
	.product6-top2{
		width: 42%;
		margin-left: 14%;
	}
	.product6-top1-text1{
		font-size: 50px;
		color: rgb(30, 80, 174);
	}
	.product6-top1-text2{
		font-size: 16px;
		color: #333;
		font-family: 微软雅黑;
		margin-top: 10px;
		font-weight: bold;
	}
	.product6-top1-text3{
		color: rgb(0, 0, 0);
		text-align: left;
		font-size: 14px;
		line-height: 26px;
		word-break: normal;
	}
	.color-text{
		color: rgb(30, 80, 174);
	}
	.product6-fot{
		display: flex;
		align-items: center;
		margin-top: 3%;
	}
	
	.fotter{
		margin-top: 3%;
		padding-left: 12%;
		padding-right: 12%;
		display: flex;
	}
	.fotter1{
		width: 50%;
		text-align: left;
		line-height: 30px;
	}
	.fotter2{
		width: 50%;
	}
	.fotter1-text{
		font-size: 26px;
		color: rgb(51, 51, 51);
	}
	.fotter1-text2{
		margin-top: 3%;
	}
	.fotter1-text2-4{
		margin-top: 3%;
	}
	
	.color-text {
		color: rgb(30, 80, 174);
	}
	.color-text2 {
		color: rgb(230, 74, 25);
	}
	.color-text3{
		color: rgb(73, 110, 232);
	}
</style>